import { ChangeDetectionStrategy, Component, computed, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TeamItemDto, UserItemDto, UserService } from '@artemis-software/wr-api';
import { Tracked } from '@/utils/signals/tracked';
import { loader } from '@/utils/signals/loader';
import { asyncComputed } from '@/utils/signals/asyncComputed';

@Component({
  standalone: false,
  selector: 'wr-user-popover',
  templateUrl: './user-popover.component.html',
  styleUrls: ['./user-popover.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserPopoverComponent {
  readonly router = inject(Router);
  readonly userService = inject(UserService);

  @Input()
  @Tracked()
  user?: UserItemDto;

  @Input()
  @Tracked()
  disableLink = false;

  loading = loader();

  navigateToDetail() {
    this.router.navigate(['user', this.user!.id]);
  }

  getTeamText(teams: string[]): string {
    return teams.join(', ');
  }
}
